import { useEffect, useRef, useState } from 'react';
import DateTimeDisplay from './DateTimeDisplay';
import './CountdownTimer.scss';

const ShowCounter = (props: {
  hours: number;
  minutes: number;
  seconds: number;
}) => {
  return (
    <div id="CountdownTimer">
      <div className="show-counter">
        <div className="countdown-wrapper">
          <DateTimeDisplay value={props.hours} type={'Hours'} isDanger={false} />
          <p>:</p>
          <DateTimeDisplay value={props.minutes} type={'Mins'} isDanger={false} />
          <p>:</p>
          <DateTimeDisplay
            value={props.seconds}
            type={'Seconds'}
            isDanger={false}
          />
        </div>
      </div>
    </div>
  );
};

function remainingParts(totalRemainingMs: number) {
  const clamped = Math.max(0, totalRemainingMs);
  const totalSeconds = Math.floor(clamped / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return { hours, minutes, seconds };
}

const CountdownTimer = (props: {
  submit: () => void;
  /** Absolute end time in epoch milliseconds (= startMs + durationSeconds * 1000). */
  targetDateInMilliseconds: number;
  autoSubmitEnabled?: boolean;
}) => {
  const [remainingMs, setRemainingMs] = useState(
    () => props.targetDateInMilliseconds - Date.now(),
  );
  const hasSubmittedRef = useRef(false);
  const [hasSeenPositiveRemaining, setHasSeenPositiveRemaining] =
    useState(false);
  const autoSubmitEnabled = props.autoSubmitEnabled !== false;

  useEffect(() => {
    setRemainingMs(props.targetDateInMilliseconds - Date.now());
    const interval = window.setInterval(() => {
      setRemainingMs(props.targetDateInMilliseconds - Date.now());
    }, 250);
    return () => window.clearInterval(interval);
  }, [props.targetDateInMilliseconds]);

  useEffect(() => {
    if (remainingMs > 0) {
      setHasSeenPositiveRemaining(true);
    }
  }, [remainingMs]);

  useEffect(() => {
    if (
      autoSubmitEnabled &&
      hasSeenPositiveRemaining &&
      remainingMs <= 0 &&
      !hasSubmittedRef.current
    ) {
      hasSubmittedRef.current = true;
      props.submit();
    }
  }, [remainingMs, hasSeenPositiveRemaining, autoSubmitEnabled, props.submit]);

  const { hours, minutes, seconds } = remainingParts(remainingMs);

  return (
    <ShowCounter hours={hours} minutes={minutes} seconds={seconds} />
  );
};

export default CountdownTimer;
